import React, { useCallback } from 'react';
import { Menu } from '@headlessui/react';

import Typography from 'components-new/typography/typography';
import Icon from 'components-new/icon/icon';
import type { IconTypes } from 'components-new/icon';
import useRedirect from 'hooks/use-redirect';

export type AvatarMenuItemType = {
  name: string;
  icon: IconTypes;
  link: string;
};

export interface AvatarMenuItemProps {
  menuItem: AvatarMenuItemType;
}

const AvatarMenuItem: React.FC<AvatarMenuItemProps> = ({ menuItem }) => {
  const redirect = useRedirect();

  const redirectToMenuItemLink = useCallback(() => {
    redirect(menuItem.link);
  }, [menuItem.link, redirect]);

  return (
    <Menu.Item>
      <button
        type="button"
        className="ui-active:bg-gray-100 ui-not-active:text-gray-900 ui-active:text-primary-500 group flex rounded-md items-center w-full px-2 py-2 text-sm"
        onClick={redirectToMenuItemLink}
      >
        <Icon
          icon={menuItem.icon}
          size={20}
          className="text-gray-700 ui-active:text-primary-500 w-5 mr-2"
        />
        <Typography variant="ui-input" as="span" className="font-light">
          {menuItem.name}
        </Typography>
      </button>
    </Menu.Item>
  );
};

export default AvatarMenuItem;
